import { createSignal } from '@verclam/pulsar';

/**
 * `create` deposits a brand-new template (name, type, description, file); `version` deposits a new
 * file for an existing template, identified by `templateId`, and carries none of the other fields —
 * they are edited separately, through `documentTemplateEditSidebarSignal`.
 */
export type DocumentTemplateUploadSidebarContext =
	| { readonly mode: 'create' }
	| { readonly mode: 'version'; readonly templateId: number };

const documentTemplateUploadSidebarSignal = createSignal<DocumentTemplateUploadSidebarContext | null>(null);

export const openDocumentTemplateUploadSidebar = (context: DocumentTemplateUploadSidebarContext): void => {
	documentTemplateUploadSidebarSignal.value = context;
};

export const closeDocumentTemplateUploadSidebar = (): void => {
	documentTemplateUploadSidebarSignal.value = null;
};

export default documentTemplateUploadSidebarSignal;
